<template>
  <div class="bg-white rounded box-shadow p-3">
    <b-modal id="user-modal" size="lg" title="User Information" hide-footer>
      <div v-show="show" class="alert alert-danger alert-dismissible fade show" role="alert">
        <span v-for="(err, index) in validation_errors" :key="index">
          {{ err[0] }} <br/>
        </span>
      </div>
      <div class="modal-content bg-white rounded box-shadow">
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="name">Name <span class="c-required">*</span></label>
            <input type="text" v-model="user.name" v-validate="'required'"  id="name" name="name" class="form-control form-control-sm" />
            <div class="invalid-feedback">User name is required</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="designation">Designation <span class="c-required">*</span></label>
            <input type="text" v-model="user.designation" v-validate="'required'" id="designation" name="designation" class="form-control form-control-sm"/>
            <div class="invalid-feedback">Designation is required</div>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="org_name">Organization Name <span class="c-required">*</span></label>
            <input type="text" v-model="user.org_name" v-validate="'required'" id="org_name" name="org_name" class="form-control form-control-sm"/>
            <div class="invalid-feedback">Organization is required</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="email">Email <span class="c-required">*</span></label>
            <input type="text" v-model="user.email" v-validate="'required'" id="email" name="email" class="form-control form-control-sm"/>
            <div class="invalid-feedback">Email is required</div>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="is_active">Status</label>
            <select v-model="user.is_active" id="is_active" name="is_active" class="form-control form-control-sm">
              <option :value="''" selected>Select a Status</option>
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </select>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="password">Password <span  v-if="!this.btn_edit" class="c-required">*</span></label>
            <input type="text" v-model="user.password" v-validate="{ required: !this.btn_edit, min: 8 }" id="password" name="password" class="form-control form-control-sm"/>
            <div  v-if="!this.btn_edit" class="invalid-feedback">Password is required</div>
          </div>
        </div>
        <div class="form-row mt-3 mb-3">
          <div class="float-right">
            <b-button v-if="!this.btn_edit" class="form-control-sm mr-2" size="sm" variant="success" @click.prevent="save">Add User</b-button>
            <b-button v-if="this.btn_edit" class="form-control-sm mr-2" size="sm" variant="warning" @click.prevent="update">Update User</b-button>
            <b-button size="sm" variant="danger" class="form-control-sm" @click="$bvModal.hide('user-modal')">Cancel</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import http from "@state/http";

export default {
  props: ["user", "btn_edit"],

  components: { },
  data() {
    return {
      validation_errors: {},
      show: false,
    };
  },
  mounted() {

  },
  methods: {
    save() {
      this.$validator.validate().then(valid => {
        if (valid) {
          http
            .post("api/users", this.user)
            .then(response => {
              if (!response.data.error) {
                this.$emit("resetForm");
                this.$bvModal.hide("user-modal");
                this.$bvToast.toast(response.data.message, {
                  title: "Success",
                  autoHideDelay: 5000,
                  variant: "success"
                });
                this.$emit("getUsers");
              }
              if (response.data.error == true) {
                this.$bvToast.toast(response.data.message, {
                  title: "Error",
                  autoHideDelay: 5000,
                  variant: "danger"
                });
              }
            })
            .catch(error => {
              this.validation_errors = error.response.data.errors;
              this.show = true;
              this.hide();
            });
        }
      });
    },
    update() {
      this.$validator.validate().then(valid => {
        if (valid) {
          http.put("api/users/" + this.user.id, this.user)
            .then(response => {
              if (!response.data.error) {
                this.$bvModal.hide("user-modal");
                this.$bvToast.toast(response.data.message, {
                  title: "Success",
                  autoHideDelay: 5000,
                  variant: "success"
                });
                this.$emit("getUsers");
              }
              if (response.data.error == true) {
                this.$bvToast.toast(response.data.message, {
                  title: "Error",
                  autoHideDelay: 5000,
                  variant: "danger"
                });
              }
            })
            .catch(error => {
              this.validation_errors = error.response.data.errors;
              this.show = true;
              this.hide();
              this.$bvToast.toast("Update Failed", {
                title: "Error",
                autoHideDelay: 5000,
                variant: "danger"
              });
            });
        }
      });
    },
    hide() {
      setTimeout(() => {
        this.show = false;
      }, 5000);
    },
  },
};
</script>
<style>
  .c-required{
    color: red;
  }
  .form-control:disabled, .form-control[readonly] {
    background-color: #e9ecef !important;
    opacity: 1;
  }
</style>
